module.exports = "/_next/static/images/db-check-9b71af8a638319221481c8208eedf757.svg";